export const GlobalConfig = {
  gameWidth: 1024,
  gameHeight: 768,
}



// WEBPACK FOOTER //
// ./src/config/global.js